import angular from 'angular';

import PrivilegeTemplateConfirmationDialog from './privilege-template-confirmation-dialog-component';

export default angular
  .module('privilege-template-confirmation-dialog', [])
  .component('privilegeTemplateConfirmationDialog', new PrivilegeTemplateConfirmationDialog());



// WEBPACK FOOTER //
// ./src/modules/privilege-templates/components/privilege-template-confirmation-dialog/privilege-template-confirmation-dialog-module.js